export default function amountMaxValidator(
  submissionProps,
  MAXIMUM_AMOUNT,
  method,
) {
  if (method === 'ACH') {
    if (
      Number(submissionProps.amount) > MAXIMUM_AMOUNT &&
      Number(submissionProps.reAmount) > MAXIMUM_AMOUNT
    ) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      const formattedMaxAmount = formatter.format(MAXIMUM_AMOUNT);
      throw new Error(
        `The amount cannot be greater than ${formattedMaxAmount}`,
      );
    } else {
      return;
    }
  } else if (method === 'Wire') {
    return;
  } else {
    throw new Error(`Invalid payment method`);
  }
}
